import React from 'react';
import { Icon } from '@iconify/react';
import axios from 'axios';
import Swal from 'sweetalert2';
import CONFIG from '../../config';

const DoctorDevTools = ({ projectId, onActionSuccess }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const simulateQueue = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            // 1. Simulate arrivals to entry
            await axios.post(`${CONFIG.API_URL}/api/candidates/simulate-arrivals`, 
                { projectId, count: 5 }, 
                { headers: { Authorization: `Bearer ${token}` } }
            );
            // 2. Move them to medical (skipping intermediate for demo)
            await axios.post(`${CONFIG.API_URL}/api/candidates/move`, 
                { projectId, fromStage: 'ENTRY', toStage: 'MEDICAL', count: 5 }, 
                { headers: { Authorization: `Bearer ${token}` } }
            );
            
            Swal.fire({
                icon: 'success',
                title: 'Medical Queue Populated',
                text: '5 candidates have been moved to the medical stage.',
                toast: true,
                position: 'top-end',
                timer: 3000,
                showConfirmButton: false
            });
            if (onActionSuccess) onActionSuccess();
        } catch (err) {
            Swal.fire('Error', 'Failed to simulate queue', 'error');
        } finally {
            setLoading(false);
        }
    };

    const injectSignature = () => {
        const canvas = document.querySelector('.dr-signature-canvas');
        if (canvas) {
            const ctx = canvas.getContext('2d');
            ctx.fillStyle = "#000";
            ctx.font = "italic 24px 'Brush Script MT', cursive";
            ctx.fillText("Dr. Remote Authorized", 150, 80);
            
            // Trigger state update in parent if possible (we may need a trick or just rely on the user clicking submit)
            // But usually this works because the Canvas is part of the DOM.
            Swal.fire({
                icon: 'success',
                title: 'Signature Injected',
                toast: true,
                position: 'top-end',
                timer: 1500,
                showConfirmButton: false
            });
        } else {
            Swal.fire('Error', 'Select a candidate first to enable signature pad.', 'warning');
        }
    };

    return (
        <div style={{ position: 'fixed', bottom: '24px', right: '24px', zIndex: 1000, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '12px' }}>
            {isOpen && (
                <div className="dr-glass-card hide-scrollbar" style={{ 
                    width: '320px', 
                    padding: '24px',
                    border: '2px solid var(--dr-primary)',
                    boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)',
                    background: 'rgba(255,255,255,0.95)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px', color: 'var(--dr-primary)' }}>
                        <Icon icon="solar:bug-bold-duotone" width="24" />
                        <h3 style={{ fontSize: '14px', fontWeight: 900, margin: 0 }}>MEDICAL REMOTE</h3>
                    </div>

                    {!projectId ? (
                        <div style={{ padding: '20px', textAlign: 'center', background: '#fef2f2', borderRadius: '12px', border: '1px dashed #ef4444' }}>
                            <p style={{ fontSize: '11px', color: '#991b1b', fontWeight: 800, margin: 0 }}>PLEASE SELECT A PROJECT FIRST</p>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <button 
                                onClick={simulateQueue} 
                                disabled={loading}
                                style={{ 
                                    padding: '12px', borderRadius: '10px', border: '1px solid var(--dr-primary)', 
                                    background: 'white', color: 'var(--dr-primary)', fontWeight: 800, 
                                    fontSize: '11px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' 
                                }}
                            >
                                <Icon icon="solar:users-group-rounded-bold" width="18" />
                                {loading ? 'PROCESSING...' : 'GENERATE 5 QUEUE ENTRIES'}
                            </button>

                            <button 
                                onClick={injectSignature}
                                style={{ 
                                    padding: '12px', borderRadius: '10px', border: '1px solid #059669', 
                                    background: 'white', color: '#059669', fontWeight: 800, 
                                    fontSize: '11px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' 
                                }}
                            >
                                <Icon icon="solar:pen-bold" width="18" />
                                INJECT TEST SIGNATURE
                            </button>

                            <div style={{ padding: '10px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '10px', color: '#64748b', fontWeight: 600 }}>
                                <Icon icon="solar:info-circle-bold" style={{ marginRight: '4px' }} />
                                Use these tools to mock candidate flow and test authorizations.
                            </div>
                        </div>
                    )}
                </div>
            )}

            <button 
                onClick={() => setIsOpen(!isOpen)} 
                title={isOpen ? 'Close Remote' : 'Open Medical Control Remote'}
                style={{ 
                    width: '56px', height: '56px', background: isOpen ? '#6b7280' : 'var(--dr-primary)', color: 'white', 
                    borderRadius: '16px', border: 'none', cursor: 'pointer', boxShadow: '0 10px 25px rgba(128,0,0,0.3)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
                <Icon icon={isOpen ? "ion:close" : "ion:game-controller"} width="28" height="28" />
            </button>
        </div>
    );
};

export default DoctorDevTools;
